module.exports = __webpack_public_path__ + "files/7e08dfd6716d56a8dc61ad55c9c12289.svg";